import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api"
import { login } from "../../services/auth"
import $ from "jquery"

import securityimg from "../../assets/img/security.png"
import blindadosite from "../../assets/img/blindadosite.png"

import Logo from "../../assets/img/logo4.jpg"
import Modal from "../content/modal"


class InscreverloginUser extends Component {

  state = {
    error:null,
    email:this.props.match.params.dadouser,
    nome:null,
    sobrenome:null,
    telefone1: null,
    telefone2:null,
    cpf:null,
    nomecompleto:null,
    cursos:[],
    idcurso:null,
    btn:'Concluir Inscrição',
    btn_disable:false
   }

  handleSignup = async e => {
    e.preventDefault();
   
    this.setState({ btn: "Aguarde", btn_disable:true });
    
    const { email, password, telefone1,telefone2, cpf, nome, sobrenome, idcurso } = this.state;

    
      if (!email || !password || !idcurso) {
          this.setState({ error: "Preencha os dados para continuar!" });
          
      } else {
      
        try{
          const { email, password,indicacao } = this.state;
      const response = await api.post("/loginthree", {idcurso,isgraduation:0, indicacao,email, password});

          login(response.data.success.token);

          const response2 = await api.post("/user/curso/matricular", { idcurso});



          this.props.history.push("/user/cursos");



        }catch(ex){
          this.setState({ error: "Ocorreu um erro, verifique os campos e tente novamente" });
          this.setState({ btn: "Concluir Inscrição", btn_disable:false });

        }
      
     

    }

  }


  async componentDidMount(){
    const response = await api.get("/cursos", {idunidade:localStorage.getItem('idunidade')});
     this.setState({ cursos: response.data,
      idcurso:localStorage.getItem("idcurso")});




      
      if(this.props.match.params.indicacao){
        this.setState({ 
          indicacao:this.props.match.params.indicacao
        });

        localStorage.setItem("indicacao", this.props.match.params.indicacao);

      }else if(!this.props.match.params.indicacao && localStorage.getItem("indicacao")){
        this.setState({ 
          indicacao:localStorage.getItem("indicacao")
        });

      }
  }

  render() {

   
    return (
      <React.Fragment>
             <Modal />
<div class="container col-lg-4">

<form class="text-center border border-light p-5" onSubmit={this.handleSignup}>

      <h3>Faculdade Olga Mettig</h3>
      <p class="h6 mb-4">Parece que você já possui uma conta</p>
    <p class="h5 mb-4">Entre & Matricula-se</p>

    {this.state.error && <h6><p>{this.state.error}</p></h6>}
    
   
      

    <input type="text" required defaultValue={this.state.email} onChange={e => this.setState({ cpf: e.target.value.slice(-1) })} class="form-control mb-4" placeholder="Seu CPF" />



    <input type="password" required onChange={e => this.setState({ password: e.target.value.slice(-1) })} class="form-control" placeholder="Password" aria-describedby="defaultRegisterFormPasswordHelpBlock" />
    <small id="defaultRegisterFormPasswordHelpBlock" class="form-text text-muted mb-4">
       
    </small>

   

    <label>Escolha seu Curso</label>
    <select class="form-control mb-4 " defaultValue={localStorage.getItem("idcurso")} required onChange={e => this.setState({ idcurso: e.target.value.slice(-1) })}>
    <option value="">Selecione seu curso</option>
    {this.state.cursos.map(el => (

el.isgraduation=='0' &&
el.status=='1' &&


      <option value={el.id} selected={el.id==localStorage.getItem("idcurso")}>{el.nome}</option>
    ))}
    </select>  

    <label>Código de Indicação?</label>
    <input type="text" defaultValue={this.state.indicacao} onChange={e => this.setState({ indicacao: e.target.value.slice(-1) })} class="form-control mb-4" aria-describedby="defaultRegisterFormPhoneHelpBlock" />

   
 
    <button class="btn btn-success my-4 btn-block" type="submit" disabled={this.state.btn_disable}>{this.state.btn}</button>

  
   
    

</form>
<center>
<img src={securityimg} class="img-thumbnail" width="170" height="120" />
<img src={blindadosite} class="img-thumbnail" width="170" height="120" />
</center>
<br></br>
</div>

      </React.Fragment>
       
    );
  }
}

export default withRouter(InscreverloginUser);


// WEBPACK FOOTER //
// ./src/pages/User/inscrevalogin.js